export default "__VITE_ASSET__dbe93530__"